import React from 'react';

const RoleTag = ({ role, name }) => <span className="RoleTag">{name}</span>;

export default RoleTag;
